import React, { useEffect, useState, useContext } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  FaArrowLeft,
  FaCheckCircle,
  FaTruck,
  FaTimes,
  FaShoppingBag,
  FaTicketAlt,
  FaCommentDots,
} from 'react-icons/fa';
import '../../../assets/css/customer/screens/Notification.css';
import MyNavbar from '../../../components/general/mynavbar/MyNavbar';
import axios from 'axios';
import MyContext from '../../../contexts/AppContext';

const CustomerNotifications = () => {
  const navigate = useNavigate();
  const { baseUrl, clearUnread,customerAuthToken } = useContext(MyContext);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = () => {
    setLoading(true);
    const customer = JSON.parse(localStorage.getItem('loggedInCustomer'));
    const formdata = new FormData();
    formdata.append('chcustomer_id', customer.id);

    axios.post(`${baseUrl}/customer/order/getCustomerNotifications`, formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${customerAuthToken}`,
        },
      },
    )
      .then((response) => {
        const sorted = response.data.notifications.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setNotifications(sorted);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchNotifications();
    clearUnread("notifications");
  }, []);

  const getConfig = (title) => {
    const t = title?.toLowerCase();

    // Order notifications
    if (t?.includes('congratulations'))
      return { icon: <FaShoppingBag />, className: 's-delivered', label: 'Order Placed' };
    if (t?.includes('shipped'))
      return { icon: <FaTruck />, className: 's-shipped', label: 'Shipped' };
    if (t?.includes('delivered'))
      return { icon: <FaCheckCircle />, className: 's-delivered', label: 'Delivered' };
    if (t?.includes('cancelled'))
      return { icon: <FaTimes />, className: 's-cancelled', label: 'Cancelled' };

    // Support ticket notifications
    if (t?.includes('resolved'))
      return { icon: <FaTicketAlt />, className: 's-delivered', label: 'Ticket Resolved' };
    if (t?.includes('rejected'))
      return { icon: <FaTicketAlt />, className: 's-cancelled', label: 'Ticket Rejected' };

    // Chat message notification (order ya ticket dono)
    if (t?.includes('message'))
      return { icon: <FaCommentDots />, className: 's-processing', label: 'New Message' };
    if (t?.includes('ticket') || t?.includes('support'))
      return { icon: <FaTicketAlt />, className: 's-processing', label: 'Support' };

    // Default
    return { icon: <FaShoppingBag />, className: 's-processing', label: 'Notification' };
  };

  const unreadCount = notifications.filter(n => n.status === 'unread').length;

const markAllRead = () => {
  const customer = JSON.parse(localStorage.getItem('loggedInCustomer'));
  const formdata = new FormData();
  formdata.append('chcustomer_id', customer.id);

  axios.post(`${baseUrl}/customer/order/markAllRead`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": `Bearer ${customerAuthToken}`,
    },
  })
    .then(() => {
      setNotifications(notifications.map(n => ({ ...n, status: 'read' })));
    })
    .catch((err) => {
      console.error('Failed to mark notifications as read:', err);
    });
};

  return (
    <div className="cn-page">
      <MyNavbar />
      <Container>
        <div className="cn-shell">
          <div className="cn-header">
            <button className="cn-back-btn" onClick={() => navigate(-1)}>
              <FaArrowLeft size={18} />
            </button>
            <h1 className="cn-title">Notifications</h1>
            <div className="cn-header-right">
              {unreadCount > 0 && <span className="cn-badge">{unreadCount}</span>}
              <button className="cn-mark-all" onClick={markAllRead}>Mark all read</button>
            </div>
          </div>

          {loading && <p className="text-center mt-4">Loading...</p>}

          {!loading && notifications.length === 0 && (
            <p className="text-center mt-4" style={{ color: '#999' }}>No notifications yet.</p>
          )}

          {!loading && notifications.length > 0 && (
            <div className="cn-list mt-3">
              {notifications.map((n) => {
                const config = getConfig(n.title);
                return (
                  <div
                    key={n.id}
                    className={`cn-row ${config.className} ${n.status === 'unread' ? 'unread' : ''}`}
                  >
                    <div className="cn-icon-wrap">{config.icon}</div>
                    <div className="cn-content">
                      <h4>{n.title}</h4>
                      <p>{n.description}</p>
                      <div className="cn-meta">
                        <span className="cn-pill">{config.label}</span>
                        <span className="cn-time">
                          {new Date(n.created_at).toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default CustomerNotifications;